import {
  INTERNAL_INTL_LOCALE,
  PUBLIC_INTL_LOCALE,
} from '@design-system/utils/publicLocalePath'

/**
 * Riscrive /en/* verso /en-wx/* prima che i18n-micro carichi il locale.
 * Il 301 en-wx → en è solo su Nitro (server/middleware) e edge Netlify:
 * farlo qui in client causava un loop con public-intl-url.client.ts.
 */
export default defineNuxtRouteMiddleware(to => {
  if (useRuntimeConfig().public.isFederated) return
  // In produzione l'edge rewrite risolve /en prima del routing Nuxt.
  if (import.meta.server && !import.meta.dev) return

  const path = to.path

  if (
    path === `/${PUBLIC_INTL_LOCALE}` ||
    path.startsWith(`/${PUBLIC_INTL_LOCALE}/`)
  ) {
    const rest = path.slice(`/${PUBLIC_INTL_LOCALE}`.length)
    const internalPath = `/${INTERNAL_INTL_LOCALE}${rest}`
    return navigateTo(
      { path: internalPath, query: to.query, hash: to.hash },
      { replace: true }
    )
  }
})
